// ==========================================
// NEW SEARCH ARCHITECTURE - Phase 1
// search-ranker.js
//
// Generic, configurable ranking utility for the new search
// architecture. Not wired into the site yet - nothing calls this.
// ==========================================

(function (global) {
  "use strict";

  var NewSearch = (global.NewSearch = global.NewSearch || {});

  if (NewSearch.ranker) {
    return;
  }

  var DEFAULT_WEIGHTS = {
    exactFieldMatch: 180,
    skuExactMatch: 220,
    fieldContains: 90,
    tokenInField: 10,
    fuzzyTokenMatch: 4,
  };

  /**
   * Minimal edit distance, used only for short typo-tolerance on
   * longer tokens (see fuzzyTokenMatch below). Not called on every
   * field/token pair - only as a fallback when a token has no direct
   * substring match, to keep this cheap.
   */
  function editDistance(a, b) {
    if (a === b) return 0;
    var m = a.length;
    var n = b.length;
    if (!m) return n;
    if (!n) return m;

    var prev = new Array(n + 1);
    var curr = new Array(n + 1);
    for (var j = 0; j <= n; j++) prev[j] = j;

    for (var i = 1; i <= m; i++) {
      curr[0] = i;
      for (j = 1; j <= n; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        curr[j] = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + cost);
      }
      var tmp = prev;
      prev = curr;
      curr = tmp;
    }
    return prev[n];
  }

  /**
   * Scores a single item against a normalized query using a list of
   * fields to inspect (e.g. ["title", "brand", "sku"]).
   *
   * item: plain object
   * normalizedQuery: string, already normalized by search-normalizer
   * fields: string[] - keys on `item` to check
   * weights: optional override of DEFAULT_WEIGHTS
   */
  function scoreItem(item, normalizedQuery, fields, weights) {
    var w = Object.assign({}, DEFAULT_WEIGHTS, weights || {});
    var q = normalizedQuery || "";
    var tokens = q ? q.split(" ").filter(Boolean) : [];
    var score = 0;

    (fields || []).forEach(function (field) {
      var value = String((item && item[field]) || "").toLowerCase();
      if (!value) return;

      if (field === "sku" && value === q && q) {
        score += w.skuExactMatch;
        return;
      }

      if (value === q) score += w.exactFieldMatch;
      else if (value.indexOf(q) !== -1 && q) score += w.fieldContains;

      var fieldTokens = null;
      tokens.forEach(function (token) {
        if (value.indexOf(token) !== -1) {
          score += w.tokenInField;
          return;
        }
        // Fuzzy fallback: only for tokens with enough signal (length >= 4)
        // to avoid noisy matches on short/common words.
        if (token.length < 4) return;
        if (!fieldTokens) fieldTokens = value.split(" ").filter(Boolean);
        for (var k = 0; k < fieldTokens.length; k++) {
          var ft = fieldTokens[k];
          if (ft.length < 4) continue;
          if (editDistance(token, ft) <= 1) {
            score += w.fuzzyTokenMatch;
            break;
          }
        }
      });
    });

    return score;
  }

  /**
   * Ranks an array of items against a query. Returns a new array of
   * { item, score } sorted descending by score. Does not mutate input.
   */
  function rank(items, normalizedQuery, fields, weights) {
    var results = (items || []).map(function (item) {
      return {
        item: item,
        score: scoreItem(item, normalizedQuery, fields, weights),
      };
    });

    results.sort(function (a, b) {
      return b.score - a.score;
    });

    return results;
  }

  NewSearch.ranker = {
    scoreItem: scoreItem,
    rank: rank,
    DEFAULT_WEIGHTS: DEFAULT_WEIGHTS,
  };
})(window);
